export { default as AcceptInvitationPage } from "./AcceptInvitationPage";
